import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
} from "constants/FormatDataContanst";
import { LINK_TYPE } from "constants/IssueInvoiceConstant";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoice from "./ListInvoice";

const ListReplaceOld = () => {
  const listLinkType = [
    LINK_TYPE.PARENT_REPLACE,
    LINK_TYPE.CHILD_REPLACE,
    LINK_TYPE.CHILD_ADJUST_TT32,
  ];
  const [filterList, setFilterList] = useState({
    "filter[link_type][in]": listLinkType,
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        listLinkTypeFilter={listLinkType}
        listStatusFilter={[
          AUTH_STATUS_NEW,
          AUTH_STATUS_APPROVE,
          AUTH_STATUS_PROGRESSING,
          AUTH_STATUS_REJECT,
          AUTH_STATUS_CANCEL_WAITING,
          AUTH_STATUS_REJECT_CANCEL,
          AUTH_STATUS_CANCEL,
          AUTH_STATUS_AR,
          AUTH_STATUS_RR,
        ]}
        title={"DANH SÁCH HÓA ĐƠN THAY THẾ"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
};

export default ListReplaceOld;
